import React from "react";
import { useTranslation } from 'react-i18next';

const AboutSection = () => {
  const { t } = useTranslation();

  const highlights = [
    {
      id: 1,
      img: "assets/images/homepage/highlight_trust.png",
      text: t('about.aiPowered'),
    },
    {
      id: 2,
      img: "assets/images/homepage/highlight_experts.png",
      text: t('about.smartAnalytics'),
    },
    {
      id: 3,
      img: "assets/images/homepage/highlight_price.png",
      text: t('about.realTimeTracking'),
    },
    {
      id: 4,
      img: "assets/images/homepage/highlight_delivery.png",
      text: t('about.instantAlerts'),
    },
  ];
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Highlight Row */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
          {highlights.map((item) => (
            <div key={item.id} className="flex flex-col items-center bg-gray-50">
              <img src={item.img} alt={item.text} className="h-16 mb-4" />
              <p className="text-2xl font-semibold whitespace-pre-line opacity-[0.7]">
                {item.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
